// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OffersPage-module__pageWrapper--Z62bp"};